import { render, staticRenderFns } from "./icon-preorder.vue?vue&type=template&id=7d02beaa"
import script from "./icon-preorder.vue?vue&type=script&lang=js"
export * from "./icon-preorder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports